import { createContext } from "react";

const SettingMiniWebContext = createContext({});

export default SettingMiniWebContext;
